export const configes = {
    domainName: "WeBuyAnySpanishLHDCars",
    domainURL: "WebuyAnyspanishlhdcars.com",
    domainId: "677e10caa287ec34fe5cff67",
  };